import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

import { useGetCurrentBasket } from '@api/basket/basketApis.rq';
import { routeList } from '@routes/routeList';

import Icon from '@utilities/icon';
import { Button } from '@com/_atoms/NewButton';
import classNames from 'classnames';

interface BasketItemsProps {
  targetRef?: RefObject<HTMLElement | null>;
}

const BasketItems = ({ targetRef }: BasketItemsProps) => {
  const { push } = useRouter();
  const { data: basketData } = useGetCurrentBasket();
  const [topPosition, setTopPosition] = useState<string | undefined>();

  useEffect(() => {
    handleWrapperUI();
    window.addEventListener('resize', handleWrapperUI);
    window.addEventListener('scroll', handleWrapperUI);

    return () => {
      window.removeEventListener('resize', handleWrapperUI);
      window.removeEventListener('scroll', handleWrapperUI);
    };
  }, [targetRef]);

  const handleWrapperUI = () => {
    if (targetRef?.current) {
      const rect = targetRef.current.getBoundingClientRect();
      const BOTTOM_NAVIGATION_VERTICAL_SPACE = 60;
      setTopPosition(`${rect.top - BOTTOM_NAVIGATION_VERTICAL_SPACE}px`);
    } else {
      setTopPosition(undefined);
    }
  };

  const renderBasketCount = () => {
    const rxCount = basketData?.refrenceNumber ? 1 : 0;

    if (!!basketData?.products?.length) {
      return basketData?.products?.length + rxCount;
    }

    return rxCount;
  };

  const navigateToBasket = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    push(routeList.basket);
  };

  return (
    <>
      {!!basketData?.products?.length || basketData?.refrenceNumber ? (
        <div
          style={topPosition ? { top: topPosition } : { bottom: '4px' }}
          className={classNames(
            'absolute left-0 w-full h-14 cursor-pointer flex justify-center items-center z-50 p-4',
          )}
        >
          <div className="w-full h-10 flex justify-between items-center rounded-full shadow-fab shadow-gray-300 border border-brand-tapsi bg-surface-primary pr-4 pl-1 py-1 gap-x-4">
            <div className="flex items-center gap-x-2">
              <Icon
                name="ShoppingCartFill"
                width={1.5}
                height={1.5}
                className="animate-pulse"
              />

              <span className="text-Body/Small text-content-primary">{`${renderBasketCount()} آیتم در سبد خرید`}</span>
            </div>

            <Button
              variant="primary"
              size="small"
              className="w-full max-w-max px-3 bg-brand-tapsi"
              onClick={navigateToBasket}
            >
              مشاهده سبد خرید
            </Button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
export default BasketItems;
